import { InjectionToken } from '@angular/core'
import { AppConfigModel } from './core/models'

export const APP_CONFIG = new InjectionToken<AppConfigModel>('app.config')
